const allowedImageMimetypes = ["image/jpeg", "image/png", "image/webp", "image/gif", "image/bmp"];

export default allowedImageMimetypes;
